// import File from 'components/process-image/File';

import Images from 'components/process-image/Image';
import ProceedButton from 'components/process-image/ProceedButton';
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { handleLoader } from 'redux/counterSlice';
import { lensRecommendation, lensRecommendationRRU } from 'services/lensService';

const ProcessImage = () => {
    const [image, setImage] = useState<any>("");
    const [recommendations, setRecommendations] = useState("");
    const [similarityDistance, setSimilarityDistance] = useState("");
    const [detectedImage, setDetectedImage] = useState("");
    const dispatch = useDispatch();
    const ron_lens_recommendation_image = useSelector((state: any) => state.lens.ron_lens_recommendation_image);
    const recommendation_image_detail = useSelector((state: any) => state.lens.recommendation_image_detail);
    const lensCounter = useSelector((state: any) => state.lens.lensCounter);


    useEffect(() => {
        if (ron_lens_recommendation_image !== "") {
            const byteCharacters = atob(ron_lens_recommendation_image);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Create Blob
            const blob = new Blob([byteArray], { type: recommendation_image_detail.type });
            const file: any = new File([blob], recommendation_image_detail.name, { type: recommendation_image_detail.type });
            setRecommendations("");
            setSimilarityDistance("");
            setDetectedImage("");
            setImage(file)
            // const imageFile: any = new File([blob], recommendation_image_detail.name, { type: recommendation_image_detail.type });
        }
    }, [ron_lens_recommendation_image, lensCounter])

    const env: string | null = localStorage.getItem("clientName")
    const handleClick = async () => {
        // hiddenFileInput.current.value = "";
        dispatch(handleLoader(true));
        const formData = new FormData();
        formData.append('file', image);
        formData.append('client_env', localStorage.getItem("clientName") as any);
        formData.append('user_name', localStorage.getItem("username") as any);
        try {
            if (env === "RRU") {
                const { result, error } = await lensRecommendationRRU(formData);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                if (result.status_code === 200) {
                    setDetectedImage(result.Image_path);
                    if (Array.isArray(result.Recommendation)) {
                        setRecommendations(result.Recommendation);
                        setSimilarityDistance(result.SimilarityPercent)
                    }
                    else if (result.status_code === 200 && !Array.isArray(result.Recommendation)) {
                        toast.info(result.message)
                    }
                }
                else {
                    toast.error(result.message)
                }
            } else {
                const { result, error } = await lensRecommendation(formData);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                if (result.status_code === 200) {
                    setDetectedImage(result.Image_path);
                    if (Array.isArray(result.Recommendation)) {
                        setRecommendations(result.Recommendation);
                        setSimilarityDistance(result.SimilarityPercent)
                    }
                    else if (result.status_code === 200 && !Array.isArray(result.Recommendation)) {
                        toast.info(result.message)
                    }
                }
                else {
                    toast.error(result.message)
                }
            }

        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    };
    return (
        <div className='p-4 content-wrapper'>
            <section className="switch-section user-management-section">
                {/* <h4 className="">Lens</h4> */}
                <div className="lens-wrap">
                    <div className="row">
                        {!detectedImage && image ?
                            <>
                                <div className="col-md-5 col-sm-12">
                                    <div className="lens-img-wrap">
                                        <img src={URL.createObjectURL(image) as any} alt="thumbnail" className="img-fluid" />
                                        <div className='text-center mt-4'>
                                            {!recommendations ? <ProceedButton handleClick={handleClick} /> : ""}
                                        </div>
                                    </div>
                                </div>
                            </> : ""
                        }
                        {detectedImage ?
                            <>
                                <div className="col-md-5 col-sm-12">
                                    <div className="lens-img-wrap">
                                        <img
                                            src={`${process.env.REACT_APP_IMAGE}/${env === "RRU" ? "RRucommendation_Engine/" : ""}${detectedImage}?timestamp=${new Date().getTime()}`}
                                            className="img-fluid"
                                            alt='detect-image'
                                        />
                                    </div>
                                </div>
                            </> : ""
                        }
                        {recommendations.length > 0 &&
                            <div className="col-md-7 col-sm-12">
                                <Images recommendations={recommendations} similarityDistance={similarityDistance} />
                            </div>
                        }
                        {detectedImage && recommendations.length === 0 &&
                            <div className="col-md-7 col-sm-12">
                                <div className="row">
                                    <div className="col-sm-12 recommended-heading">
                                        <p><b>Recommended Products</b> (with similarity percentage):</p>
                                    </div>
                                </div>
                                <div className="row eq-height">
                                    <h5>Oops, no similar products found!</h5>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ProcessImage